import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  IconButton,
  InputAdornment,
  InputBase,
  Paper,
  Typography,
} from '@mui/material';
import { colors } from '../theme';
import { useState } from 'react';

interface CustomInputProps {
  isIconActive: boolean;
  label: string;
  placeholder: string;
  name: string;
  required: boolean;
  type: string;
  value: string;
  className: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  labelClass?: string;
}

const CustomInput: React.FC<CustomInputProps> = ({
  isIconActive,
  label,
  placeholder,
  name,
  required,
  type,
  value,
  className,
  handleChange,
  labelClass,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePw = () => setShowPassword(!showPassword);
  const getType = () => {
    if (type === 'password') {
      return showPassword ? 'text' : type;
    }
    return type;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignContent="center"
      justifyContent="flex-start"
      mb={2}
    >
      <Box display="flex" flexDirection="column" justifyContent="flex-start">
        <Typography
          color={colors.purplePrimary}
          pb={1}
          fontWeight="500"
          className={labelClass || ''}
        >
          {label}
        </Typography>
        <Paper
          sx={{
            background: colors.white,
            width: '100%',
            boxShadow: 'none',
          }}
        >
          <InputBase
            onChange={handleChange}
            placeholder={placeholder}
            className={className}
            name={name}
            fullWidth
            value={value}
            typeof={type}
            required={required}
            type={getType()}
            sx={{
              bgcolor: colors.white,
              p: 1,
              borderRadius: '5px',
              border: `1px solid ${colors.input[100]}`,
              boxShadow: 'none',
              color: colors.black,
              '& input': {
                color: colors.black,
                fontSize: '0.9rem',
                '::placeholder': {
                  fontSize: '0.9rem',
                },
              },
            }}
            endAdornment={
              isIconActive && (
                <InputAdornment position="end" sx={{ pr: 1 }}>
                  <IconButton edge="end" onClick={togglePw}>
                    {showPassword ? (
                      <Visibility sx={{ color: colors.purplePrimary }} />
                    ) : (
                      <VisibilityOff sx={{ color: colors.purplePrimary }} />
                    )}
                  </IconButton>
                </InputAdornment>
              )
            }
          />
        </Paper>
      </Box>
    </Box>
  );
};

export default CustomInput;
